<div class="files-column">
  <div class="column-header">
    <app-caption [text]="header"></app-caption>
    <div class="task-bar">
      <button
        *ngIf="!disableUpload && !hasCameraAccess"
        mat-flat-button
        class="btn-file-upload"
        color="primary"
        type="button"
        (click)="fileUpload.value = ''; fileUpload.click()"
      >
        <label>
          <mat-icon>add_circle</mat-icon>
          {{ 'ADD' | translate }}
        </label>
      </button>
      <input style="display: none;"
        #fileUpload
        (input)="handleFileUpload($event, false)"
        multiple
        type="file"
        [accept]="acceptedTypes"
      />
      <button
      *ngIf="!disableUpload && hasCameraAccess"
      mat-flat-button
      class="btn-file-upload"
      color="primary"
      type="button"
      (click)="fileUploadCam.value = ''; fileUploadCam.click()"
      >
        <label>
          <mat-icon>add_a_photo</mat-icon>
        </label>
      </button>
      <input
        style="display: none;"
        #fileUploadCam
        (input)="handleFileUpload($event, true)"
        multiple
        capture
        type="file"
        [accept]="acceptedTypes"
      />
    </div>
  </div>
  <ol *ngIf="files.length; else noFiles" class="files-list">
    <li class="file-item" *ngFor="let file of files">
      <div class="file-item-wrapper">
        <img *ngIf="isPhotoAttachment(file) && file.thumbnail" [src]="file.thumbnail" (click)="getOriginalSize(file)">
        <span class="file-item-label">{{file.originalFilename}}</span>
        <div class="file-item-buttons">
          <button
            *ngIf="!disableDownload && !offlineMode"
            mat-icon-button
            type="button"
            class="file-item-btn"
            (click)="download(file)"
          >
            <mat-icon class="material-icons-outlined" fontIcon="file_download"></mat-icon>
          </button>
          <button
            *ngIf="!disableDelete"
            mat-icon-button
            type="button"
            class="file-item-btn"
            (click)="delete(file)"
          >
            <mat-icon class="material-icons-outlined" fontIcon="delete"></mat-icon>
          </button>
        </div>
      </div>
    </li>
  </ol>
  <span class="upload-limit">{{ hintKey | translate }}</span>
  <ng-template #noFiles>
    <i>{{ 'NO_FILES' | translate }}</i>
  </ng-template>
</div>

<div *ngIf="originalSize" class="overlay">
  <button *ngIf="!hasCameraAccess" class="btn-new-window" type="button" mat-icon-button (click)="openNewWindow()">
    <mat-icon>open_in_new</mat-icon>
  </button>
  <button class="btn-close" mat-icon-button (click)="closePreview()">
    <mat-icon>close</mat-icon>
  </button>
  <img [src]="originalSize">
</div>
